import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import { ApplicationRoutes, FeatureFlags } from '../../../../constants';
import { useGeneralContext } from '../../../../services/GeneralContext';
import LoginMenu from '../../../api-authorization/LoginMenu';
import NectarineButton from '../../../ui/NectarineButton/NectarineButton';
import flower from './../../../../img/flower.jpg';
import logoImage from './../../../../img/nectarine-logo.png';
import snowman from './../../../../img/snowman.png';
import './NavMenu.scss';

export const NavMenu: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);

  const { checkFeatureFlag, triggerEasterEgg } = useGeneralContext();

  const showWinterEasterEggs = checkFeatureFlag(FeatureFlags.WinterEasterEggs);
  const showSpringEasterEggs = checkFeatureFlag(FeatureFlags.SpringEasterEggs);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <header>
      <Navbar className="home-top-navbar navbar-expand-md navbar-toggleable-md ng-white mb-3" container light>
        <NavbarBrand tag={Link} to={ApplicationRoutes.Root}>
          <img src={logoImage} alt="Nectarine" className="logo" />

          {showWinterEasterEggs ? <img src={snowman} style={{ width: '30px' }} className="ms-3 position-absolute" /> : <></>}

          {showSpringEasterEggs ? (
            <img
              src={flower}
              style={{ width: '30px' }}
              className="ms-3 position-absolute"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                triggerEasterEgg('flowers');
              }}
            />
          ) : (
            <></>
          )}
        </NavbarBrand>

        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse className="d-md-inline-flex flex-md-row-reverse" isOpen={!collapsed} navbar>
          <ul className="navbar-nav flex-grow">
            <a href="/#howitworks" className="nav-link">
              How it Works
            </a>

            <a href="/#pricing" className="nav-link">
              Pricing
            </a>

            <a href="/#experts" className="nav-link">
              Experts
            </a>

            <a href={`/${ApplicationRoutes.MoneyTools}`} className="nav-link">
              Money Tools
            </a>

            <div className="mx-3"></div>

            <LoginMenu location="top" />

            <div className="mt-2">
              <NectarineButton text="Get Started" size="smedium" href={ApplicationRoutes.Root} hrefOpensNewTab={false} />
            </div>
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
};
